import React, { ReactElement } from "react";
import styles from "./HelpMeItemContainer.module.scss";
import { Popup } from "semantic-ui-react";

type THelpMeItemContainer = {
  title: string;
  subTitle?: string;
  children: ReactElement;
  required?: boolean;
  extraPaddings?: boolean;
  isSmall?: boolean;
  id?: string;
  popupText?: string;
  popupIcon?: string;
};

const HelpMeItemContainer: React.FC<THelpMeItemContainer> = ({
  title,
  subTitle,
  children,
  required = false,
  extraPaddings,
  id,
  isSmall = false,
  popupText,
  popupIcon,
}) => {
  return (
    <div
      className={
        styles.HelpMeItemContainer +
        ` ${extraPaddings ? styles.ExtraPaddings : ""}`
      }
      data-small={isSmall}
      id={id}
    >
      <div className={styles.HelpMeItemContainer_Title} data-small={isSmall}>
        <h3>{title}</h3>
        {!required && (
          <div className={styles.HelpMeItemContainer_Title_NonRequired}>
             - необязательно
          </div>
        )}
        <CustomPopup popupText={popupText} popupIcon={popupIcon} />
      </div>
      {subTitle && (
        <div className={styles.HelpMeItemContainer_SubTitle}>{subTitle}</div>
      )}
      <div className={styles.HelpMeItemContainer_Children}>{children}</div>
    </div>
  );
};

type TCustomPopup = {
  popupText?: string;
  popupIcon?: string;
};

const CustomPopup: React.FC<TCustomPopup> = ({ popupIcon, popupText }) => {
  if (!popupIcon || !popupText) return null;
  return (
    <Popup
      inverted
      basic
      style={{ backgroundColor: "#333333", zIndex: 10000 }}
      hideOnScroll={true}
      position={"top center"}
      trigger={
        <div className={styles.HelpMeItemContainer_Title_Popup}>
          <img src={popupIcon} alt="PopupInfo" />
        </div>
      }
    >
      {popupText}
    </Popup>
  );
};

export default HelpMeItemContainer;
